export const URL = process.env.URL
export const CHURCH_ROLE_NAME = 'CHURCHUSER'
export const ADMIN_ROLE_NAME = 'ADMIN'

export default {
  URL
}
